import { useCallback, useMemo } from 'react';
import { computePriceBrackets, dayPriceOf, dayTierOf } from '@utils/priceTiers';

/**
 * Price brackets + per-day tier/price lookups over /calendar-availability
 * rows (see @utils/priceTiers; prices in cents). `getDayTier` returns 'low' |
 * 'medium' | 'high' | null; consumers that show only the endpoints map
 * 'medium' to null.
 */
export default function useDayPriceTiers({ rows, priceDisplayMode = 'gross' }) {
  const brackets = useMemo(
    () => computePriceBrackets(rows, priceDisplayMode),
    [rows, priceDisplayMode],
  );
  const getDayTier = useCallback(
    (date) => dayTierOf(rows, brackets, date, priceDisplayMode),
    [rows, brackets, priceDisplayMode],
  );
  const getDayPrice = useCallback(
    (date) => dayPriceOf(rows, date, priceDisplayMode),
    [rows, priceDisplayMode],
  );
  return { brackets, getDayTier, getDayPrice };
}
